// extracted by mini-css-extract-plugin
export default {"lds-roller":"style_lds-roller__N3Vzl","div-after":"style_div-after__j2fde"};